import { ITheme } from './theme.interface';
import { IThemeOption } from './theme-option.interface';
import defaultThemeJson from './themes/instalcorp.json';

/**
 * Where themes come from. The default one is bundled, so it applies on the
 * server render and on the first paint with nothing to fetch. Every other
 * theme is a JSON file in public/themes/, listed in public/themes/index.json,
 * fetched when chosen.
 */
export class ThemeRegistry {
  static readonly DEFAULT_THEME: ITheme = defaultThemeJson as ITheme;
  static readonly DEFAULT_OPTION: IThemeOption = { id: defaultThemeJson.id, name: defaultThemeJson.name };
  static readonly BASE_URL = '/themes';
  static readonly INDEX_URL = `${ThemeRegistry.BASE_URL}/index.json`;

  static url(id: string): string {
    return `${ThemeRegistry.BASE_URL}/${encodeURIComponent(id)}.json`;
  }
}
